import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {Ministry} from './ministry.model';
import * as MinistryActions from './ministry.actions';

export const ministriesFeatureKey = 'ministries';

export interface State extends EntityState<Ministry> {
  // additional entities state properties
}

export const adapter: EntityAdapter<Ministry> = createEntityAdapter<Ministry>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(MinistryActions.addMinistry,
    (state, action) => adapter.addOne(action.ministry, state)
  ),
  on(MinistryActions.upsertMinistry,
    (state, action) => adapter.upsertOne(action.ministry, state)
  ),
  on(MinistryActions.addMinistrys,
    (state, action) => adapter.addMany(action.ministrys, state)
  ),
  on(MinistryActions.upsertMinistrys,
    (state, action) => adapter.upsertMany(action.ministrys, state)
  ),
  on(MinistryActions.updateMinistry,
    (state, action) => adapter.updateOne(action.ministry, state)
  ),
  on(MinistryActions.updateMinistrys,
    (state, action) => adapter.updateMany(action.ministrys, state)
  ),
  on(MinistryActions.deleteMinistry,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(MinistryActions.deleteMinistrys,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(MinistryActions.loadMinistrys,
    (state, action) => adapter.setAll(action.ministrys, state)
  ),
  on(MinistryActions.clearMinistrys,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
